// src/pages/fleet/master/StateMasterPage.tsx — State master (LGD reference list).
//
// Read-only on purpose. These are the government's own LGD codes and IFMS
// validates against them, so a state invented here would only produce trips
// IFMS rejects. The list is replaced by updating backend/src/data/lgd.json.
import React from 'react';
import MasterTable from './MasterTable';
import useLgd, { LgdState } from './useLgd';

export default function StateMasterPage() {
  const { states, districts, loading, error } = useLgd();
  const districtCount = (code: string) => districts.filter((d) => d.stateCode === code).length;

  return (
    <MasterTable<LgdState>
      icon="globe" title="State" subtitle="LGD state codes used for destination reporting to IFMS"
      idKey="code" rows={states} addLabel="State"
      banner={error
        ? error
        : <><b>Government reference list.</b> The {states.length || 36} states and union territories published by
            lgdirectory.gov.in. IFMS receives the LGD State Code as <code>destinationStateCode</code>, so this list is
            read-only — a dealer's state is set in Master → Vendor, not here.</>}
      emptyText={loading ? 'Loading the LGD list…' : 'The LGD list could not be loaded'}
      searchKeys={['name', 'code', 'short']}
      filters={[{ key: 'ut', label: 'Type', options: [{ value: 'false', label: 'State' }, { value: 'true', label: 'Union Territory' }] }]}
      stats={[
        { label: 'States & UTs', value: states.length, tint: 'var(--fx-accent)' },
        { label: 'States', value: states.filter((s) => !s.ut).length, tint: 'var(--fx-green)' },
        { label: 'Union Territories', value: states.filter((s) => s.ut).length, tint: 'var(--fx-text-3)' },
        { label: 'Districts mapped', value: districts.length, tint: 'var(--fx-purple)' },
      ]}
      columns={[
        { key: 'code', label: 'LGD State Code', width: 140, render: (r) => <b style={{ fontFamily: 'DM Mono, monospace' }}>{r.code}</b> },
        { key: 'name', label: 'State Name', render: (r) => <b>{r.name}</b> },
        { key: 'short', label: 'Short' },
        { key: 'ut', label: 'Type', width: 150, render: (r) => (r.ut ? 'Union Territory' : 'State'), csvValue: (r) => (r.ut ? 'Union Territory' : 'State') },
        { key: 'districts', label: 'Districts', sortable: false, render: (r) => districtCount(r.code), csvValue: (r) => districtCount(r.code) },
      ]}
      fields={[]}
    />
  );
}
